import { render } from "./PlanFeeTerms.vue?vue&type=template&id=e3d66c04&scoped=true"
import script from "./PlanFeeTerms.vue?vue&type=script&lang=js"
export * from "./PlanFeeTerms.vue?vue&type=script&lang=js"

import "./PlanFeeTerms.vue?vue&type=style&index=0&id=e3d66c04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d66c04"]])

export default __exports__